/**
 * Query string for GET /lines-of-business with marketplace-only lines (CRM-267).
 */
export function marketplaceLinesOfBusinessQueryString(
  classOfBusinessId: number,
  lineTypeId: number,
  pageSize = 999
): string {
  const params = new URLSearchParams();
  params.set('page[size]', String(pageSize));
  params.set('filter[class_of_business_id]', String(classOfBusinessId));
  params.set('filter[line_type_id]', String(lineTypeId));
  params.set('filter[has_marketplace_products]', '1');
  return params.toString();
}
